// extracted by mini-css-extract-plugin
export default {"box":"mainLogo_box__hdNX1","mr":"mainLogo_mr__jtiHd","byte":"mainLogo_byte__bKBfz","bgText":"mainLogo_bgText__XKAEd"};